import React from 'react'
import { Link } from 'react-router-dom'
import { Modal, ModalHeader, ModalBody, Button,Col,Card } from 'reactstrap'
import queryString from 'query-string'
import removeModalFromQuery from '../../../helpers/assessment/removeModalFromQuery';
import CircleAnswer from './ItemCircles'

export default function AssessSubmitModal ({
  handleSubmitSubtest,
   isOpen,
    navTo,
     search,
     user,
     activeItem,
     answersByItem,
     userAssessment,
     groupUA,
     selectedStudent, 
     subtestId,
     itemNumber,
     completed,
     isGroup,
     selectedGroupUA,
     items,
     assessmentId
    
    }) {
  // function removeModalFromQuery (search) {
  //   let query = queryString.parse(search)
  //   delete query.m
  //   return queryString.stringify(query)
  // }
  const noModalQuery = removeModalFromQuery(search)
//  function toggle() {
//    navTo()
//  }
  return (
    <div className="assessment-model">
    <Modal
      isOpen={isOpen}
      toggle={() => navTo(`?${noModalQuery}`)}
      className='modal-primary modal-custom'
    >
      <ModalHeader
        toggle={() => navTo(`?${noModalQuery}`)}
      >
        Confirm Submission
      </ModalHeader>
      <ModalBody>
        <p>
          {`Are you ready to submit your test? You will not 
          be able to attempt any more questions in this test 
          once you submit.`}<br />
          {"Below is your digital bubble sheet. Question you have answered are shaded."}<br />
          {" Click any bubble to return to that question."}
          <Col xs='12' xl='12'>
          <Card className='test-overview-nav'>
          <CircleAnswer 
           user={user}
           activeItem={activeItem}
           answersByItem={answersByItem}
           userAssessment={userAssessment}
           groupUA={groupUA}
           selectedStudent={selectedStudent}
           subtestId={subtestId}
           itemNumber={itemNumber}
           completed={completed}
           isGroup={isGroup}
           selectedGroupUA={selectedGroupUA}
           items={items}
           assessmentId={assessmentId}
          
          />
          </Card>
          </Col>
        </p>
        <div className="text-center">
        <Link to='?item=results'>
          <Button
            onClick={() => handleSubmitSubtest()}
          >
            Submit
          </Button>
        </Link>
        <Link to={`?${noModalQuery}`}>
          <Button>
            Cancel
          </Button>
        </Link>
        </div>
      </ModalBody>
    </Modal>
    </div>
  )
}


// WEBPACK FOOTER //
// ./src/components/Assessment/AssessTest/AssessSubmitModal.js